export const RECIPE_SEARCH_PATH = '/ecom/recipes/search';
export const RECIPE_SEARCH_ID = 'recipe-search';

export const RECIPE_QUERY_SEARCH_TERM = 'recipeSearch';
export const RECIPE_QUERY_SORT_BY = 'sortBy';
export const RECIPE_QUERY_PAGE = 'page';
export const RECIPE_QUERY_START_PAGE = 'startPage';

export const RECIPE_LAST_PUBLISHED = 'LAST_PUBLISHED';
export const RECIPE_FEATURED_LAST_PUBLISHED = 'FEATURED_LAST_PUBLISHED' as const;

export const RECIPE_FILTER_SUFFIX = '_flt';
export const RECIPE_FILTER_TOTAL_TIME = 'Total Time';

export const RECIPE_SORT_OPTIONS = [
  { label: 'Featured', value: RECIPE_FEATURED_LAST_PUBLISHED },
  { label: 'Recently added', value: RECIPE_LAST_PUBLISHED },
  { label: 'Alphabetical', value: 'A_2_Z' },
  { label: 'Alphabetical reverse', value: 'Z_2_A' },
] as const;

export const RECIPE_SEARCH_SORT_OPTIONS = [
  { label: 'Most relevant', value: '' },
  ...RECIPE_SORT_OPTIONS,
];
